<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ data.InvoiceSettingGroupID ? 'Düzenle' : 'Yeni Hizmet'}}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <!-- Product Image -->
        <template v-if="dataImg">
          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="dataImg" alt="img" class="responsive" />
          </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input
              type="file"
              class="hidden"
              ref="updateImgInput"
              @change="updateCurrImg"
              accept="image/*"
            />
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">Update Image</vs-button>
            <vs-button type="flat" color="#999" @click="dataImg = null">Remove Image</vs-button>
          </div>
        </template>
        <vs-tabs
          :position="isSmallerScreen ? 'top' : 'left'"
          class="tabs-shadow-none"
          id="product-tabs"
          v-model="vsTabData"
          :key="isSmallerScreen"
        >
          <vs-tab
            icon-pack="feather"
            icon="icon-file-text"
            :label="!isSmallerScreen ? 'İçerik' : ''"
          >
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <ValidationObserver tag="form" ref="productFormStep1" v-on:submit.prevent>
                <ValidationProvider
                  :name="$t('Table.PaymentGroup.ProductTitle')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <vs-input
                    :label="$t('Table.PaymentGroup.ProductTitle')"
                    v-model="formData.ProductTitle"
                    class="w-full"
                    name="item-name"
                  />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider
                  :name="$t('Table.PaymentGroup.ProductDesc')"
                  rules
                  v-slot="{ errors }"
                >
                  <vs-input
                    :label="$t('Table.PaymentGroup.ProductDesc')"
                    v-model="formData.ProductDesc"
                    class="mt-5 w-full"
                    name="item-desc"
                  />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider
                  :name="$t('Table.PaymentGroup.ProductPrice')"
                  rules="required|min_value_currency"
                  v-slot="{ errors }"
                >
                  <vs-input
                    :label="$t('Table.PaymentGroup.ProductPrice')"
                    v-model="formData.Price"
                    class="mt-5 w-full"
                    name="item-price"
                    v-currency
                  />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </ValidationObserver>
            </div>
          </vs-tab>

          <vs-tab
            icon-pack="feather"
            icon="icon-credit-card"
            :label="!isSmallerScreen ? 'Ödeme Ayarları' : ''"
          >
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <ValidationObserver tag="form" ref="productFormStep2" v-on:submit.prevent>
                <vs-collapse accordion class="p-0">
                  <template v-for="(campaign,index) in campaigns">
                    <vs-collapse-item :open="index == 0 ? true : false" :key="campaign.value">
                      <div slot="header">{{ campaign.text }} Ödeme Seçenekleri</div>
                      <ValidationProvider
                        :name="$t('Table.PaymentGroup.Installment_Cash' + index)"
                        :rules="campaign.value == 'CASH' ? 'required|min_value:1' : ''"
                        v-slot="{ errors }"
                        :key="campaign.value"
                      >
                        <v-select
                          v-model="formData.Installments[campaign.value].Paymethod"
                          class="w-full mb-5"
                          :options="paymethods"
                          :reduce="item => item.value"
                          name="item-installement-x1"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        />
                        <span class="text-danger text-sm text-select">{{ errors[0] }}</span>
                      </ValidationProvider>
                      <vs-table
                        v-if="campaign.value != 'CASH'"
                        class="w-full mt-5"
                        :data="formData.Installments[campaign.value].Installments"
                      >
                        <template slot="thead">
                          <vs-th>Aktif</vs-th>
                          <vs-th>Taksit</vs-th>
                          <vs-th>Oran</vs-th>
                        </template>
                        <template slot-scope="{data}">
                          <vs-tr v-for="(dc,index_dc) in data" :key="index_dc">
                            <vs-td>
                              <vs-checkbox :id="dc.Index" v-model="data[index_dc].Checked" />
                            </vs-td>
                            <vs-td>
                              <b
                                class="block text-center"
                                @click="data[index_dc].Checked = !data[index_dc].Checked"
                              >{{ dc.Index }}</b>
                            </vs-td>
                            <vs-td class="p-0">
                              <vs-input
                                icon-pack="feather"
                                icon="icon-percent"
                                name="item-price"
                                v-model="data[index_dc].Comission"
                                v-mask="['##.##']"
                              />
                            </vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </vs-collapse-item>
                  </template>
                </vs-collapse>
              </ValidationObserver>
            </div>
          </vs-tab>
          <vs-tab
            icon-pack="feather"
            icon="icon-gift"
            :label="!isSmallerScreen ? 'İndirim Ayarları' : ''"
          >
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <ValidationObserver tag="form" ref="productFormStep3" v-on:submit.prevent>
                <div v-for="(data,index) in formData.Discounts" :key="index">
                  <vx-card
                    :title="(index + 1) +'-)İndirim'"
                    class="mb-5"
                    removeCardNoAction
                    @remove="removeDiscount(index)"
                  >
                    <h6 class="mb-5">İndirim Kimlere Uygulanacak?</h6>
                    <ValidationProvider
                      rules="required"
                      :name="$t('Table.PaymentGroup.NotifyEmail')"
                      v-slot="{ errors }"
                    >
                      <ul class="centerx">
                        <li>
                          <vs-radio
                            v-model="data.UseType"
                            :vs-name="'discount_' + index"
                            vs-value="all"
                          >Herkese</vs-radio>
                        </li>
                        <li>
                          <vs-radio
                            v-model="data.UseType"
                            :vs-name="'discount_' + index"
                            vs-value="staff"
                          >Sadece Akademik ve İdari Personel</vs-radio>
                        </li>
                        <li>
                          <vs-radio
                            v-model="data.UseType"
                            :vs-name="'discount_' + index"
                            vs-value="student"
                          >Sadece Öğrencilere</vs-radio>
                        </li>
                        <!-- <li>
                          <vs-radio
                            v-model="data.UseType"
                            :vs-name="'discount_' + index"
                            vs-value="custom"
                          >Kişiye Özel</vs-radio>
                        </li>-->
                      </ul>
                      <span class="text-danger text-sm text-select">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <ValidationProvider
                      :name="$t('Table.PaymentGroup.DiscountTitle') + index"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <vs-input
                        :label="$t('Table.PaymentGroup.DiscountTitle')"
                        v-model="data.DiscountDesc"
                        class="mt-5 w-full"
                        name="item-name"
                      />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <ValidationProvider
                      :name="$t('Table.PaymentGroup.DiscountPercent') + index"
                      v-slot="{ errors }"
                    >
                      <vs-input
                        icon-pack="feather"
                        icon="icon-percent"
                        :label="$t('Table.PaymentGroup.DiscountPercent')"
                        v-model="data.DiscountRate"
                        class="mt-5 w-full"
                        name="item-price"
                        v-mask="['##.##']"
                      />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <ValidationProvider
                      :name="$t('Table.PaymentGroup.DiscountPrice') + index"
                      v-slot="{ errors }"
                    >
                      <vs-input
                        :label="$t('Table.PaymentGroup.DiscountPrice')"
                        v-model="data.DiscountPrice"
                        class="mt-5 w-full"
                        name="item-price"
                        v-currency
                      />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </vx-card>
                </div>
              </ValidationObserver>

              <vs-button class="mr-6" color="success" @click="newDiscount()">Yeni İndirim Oluştur</vs-button>
            </div>
          </vs-tab>

          <vs-tab
            icon-pack="feather"
            icon="icon-bell"
            :label="!isSmallerScreen ? 'Bilgilendirme' : ''"
          >
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <ValidationObserver tag="form" ref="productFormStep4" v-on:submit.prevent>
                <ValidationProvider
                  :name="$t('Table.PaymentGroup.NotifyEmail')"
                  v-slot="{ errors }"
                >
                  <label
                    class="vs-select--label block mt-5"
                  >{{ $t('Table.PaymentGroup.NotifyEmail') }}</label>
                  <v-select
                    v-model="formData.NotifyMails"
                    class="w-full"
                    multiple
                    taggable
                    :closeOnSelect="false"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    name="item-category"
                  >
                    <div slot="no-options">{{$t('Table.PaymentGroup.NotifyEmailWarning')}}</div>
                  </v-select>
                  <span class="text-danger text-sm text-select">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider :name="$t('Table.PaymentGroup.NotifySMS')" v-slot="{ errors }">
                  <label
                    class="vs-select--label block mt-5"
                  >{{ $t('Table.PaymentGroup.NotifySMS') }}</label>
                  <v-select
                    v-model="formData.NotifyGsms"
                    class="w-full"
                    multiple
                    taggable
                    :closeOnSelect="false"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    name="item-category"
                  >
                    <div slot="no-options">{{$t('Table.PaymentGroup.NotifySMSWarning')}}</div>
                  </v-select>
                  <span class="text-danger text-sm text-select">{{ errors[0] }}</span>
                </ValidationProvider>
              </ValidationObserver>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button
        class="mr-6 vs-con-loading__container"
        @click="submitData"
        id="sidebarSubmit"
      >Kaydet</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Vazgeç</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import StaffApi from "@/api/staff";
import vSelect from "vue-select";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      this.initValues();
    }
  },
  data() {
    return {
      vsTabData: 0,
      formValid: false,
      submitBusy: false,
      formData: {
        InvoiceSettingGroupID: null,
        ProductTitle: "",
        ProductDesc: "",
        Price: null,
        Installments: {},
        NotifyMails: [],
        NotifyGsms: [],
        Discounts: []
      },
      dataId: null,
      dataName: "",
      dataCategory: [],
      dataImg: null,
      dataOrder_status: "pending",
      dataPrice: 0,
      paymethods: [],
      campaigns: [
        { text: "Peşin", value: "CASH" },
        { text: "World", value: "WORLD" },
        { text: "Bonus", value: "BONUS" }
      ],
      category_choices: [
        { text: "Audio", value: "audio" },
        { text: "Computers", value: "computers" },
        { text: "Fitness", value: "fitness" },
        { text: "Appliance", value: "appliance" }
      ],

      order_status_choices: [
        { text: "Pending", value: "pending" },
        { text: "Canceled", value: "canceled" },
        { text: "Delivered", value: "delivered" },
        { text: "On Hold", value: "on_hold" }
      ],
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },
  created() {
    this.fetchPaymethods();

    for (let index = 0; index < this.campaigns.length; index++) {
      const element = this.campaigns[index];

      this.formData.Installments[element.value] = {
        Paymethod: 0,
        Installments: []
      };

      for (let z = 2; z <= 12; z++) {
        this.formData.Installments[element.value].Installments.push({
          Index: z,
          Checked: false,
          Comission: 0
        });
      }
    }
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          this.initValues();
        }
      }
    }
  },
  methods: {
    async fetchPaymethods() {
      let response = await StaffApi.getPaymethods(this);

      if (!response.data.error) {
        this.paymethods = response.data;
      }
    },
    async sleep(msec) {
      return new Promise(resolve => setTimeout(resolve, msec));
    },
    async checkInvalidSubmit() {
      console.log(this.formData);
      this.formValid = false;

      for (let index = 0; index < 4; index++) {
        this.vsTabData = index;

        var sleep = await this.sleep(100);
        switch (index) {
          case 0:
            this.formValid = await this.$refs.productFormStep1.validate();
            break;
          case 1:
            this.formValid = await this.$refs.productFormStep2.validate();
            break;
          case 2:
            this.formValid = await this.$refs.productFormStep3.validate();
            break;
          case 3:
            this.formValid = await this.$refs.productFormStep4.validate();
            break;
        }

        if (!this.formValid) return false;
      }

      return this.formValid;
    },
    removeDiscount(index) {
      this.formData.Discounts.splice(index, 1);
    },
    newDiscount() {
      this.formData.Discounts.push({
        UseType: "all",
        DiscountDesc: "",
        DiscountRate: 0.0,
        DiscountPrice: 0.0
      });
    },
    initValues() {
      this.vsTabData = 0;
      this.formValid = false;
      this.formData = {
        InvoiceSettingGroupID: 0,
        ProductTitle: "",
        ProductDesc: "",
        Price: null,
        Installments: {},
        NotifyMails: [],
        NotifyGsms: [],
        Discounts: []
      };

      if (this.data.InvoiceSettingGroupID) {
        this.formData.InvoiceSettingGroupID = this.data.InvoiceSettingGroupID;
        this.formData.ProductTitle = this.data.ProductTitle;
        this.formData.ProductDesc = this.data.ProductDesc;
        this.formData.Price = this.$options.filters.currency(this.data.Price);
        this.formData.NotifyMails = this.data.NotifyMails
          ? this.data.NotifyMails.toString().split(",")
          : [];
        this.formData.NotifyGsms = this.data.NotifyGsms
          ? this.data.NotifyGsms.toString().split(",")
          : [];
      }

      if (this.data.DiscountRules) {
        this.data.DiscountRules.forEach(el => {
          var dcType = "all";

          if (el.UseOnlyPerson) dcType = "staff";
          else if (el.UseOnlyStudent) dcType = "student";

          this.formData.Discounts.push({
            UseType: dcType,
            DiscountDesc: el.DiscountDesc,
            DiscountRate: el.DiscountRate,
            DiscountPrice: el.DiscountPrice
              ? this.$options.filters.currency(el.DiscountPrice)
              : el.DiscountPrice
          });
        });
      }

      if (this.data.AvailableInstallments) {
        var cashPaymethod = this.data.AvailableInstallments.find(
          el => el.InstallmentIndex == 1
        );

        this.formData.Installments["CASH"] = {
          Paymethod: cashPaymethod ? cashPaymethod.PaymethodID : 0,
          Installments: []
        };

        for (let index = 0; index < this.campaigns.length; index++) {
          const element = this.campaigns[index];
          if (element.value == "CASH") continue;

          var findCampaign = this.data.AvailableInstallments.find(
            el => el.CampaignKey == element.value
          );

          this.formData.Installments[element.value] = {
            Paymethod: findCampaign ? findCampaign.PaymethodID : 0,
            Installments: []
          };

          for (let z = 2; z <= 12; z++) {
            var findCampaign = this.data.AvailableInstallments.find(
              el => el.InstallmentIndex == z && el.CampaignKey == element.value
            );

            this.formData.Installments[element.value].Installments.push({
              Index: findCampaign ? findCampaign.InstallmentIndex : z,
              Checked: findCampaign ? true : false,
              Comission: findCampaign ? findCampaign.CommissionRate : 0
            });
          }
        }

        console.log(this.formData.Installments);
      } else {
        for (let index = 0; index < this.campaigns.length; index++) {
          const element = this.campaigns[index];

          this.formData.Installments[element.value] = {
            Paymethod: 0,
            Installments: []
          };

          for (let z = 2; z <= 12; z++) {
            this.formData.Installments[element.value].Installments.push({
              Index: z,
              Checked: false,
              Comission: 0
            });
          }
        }
      }
    },
    async submitData() {
      if (this.submitBusy) return;

      this.submitBusy = true;

      const isValid = await this.checkInvalidSubmit();

      if (isValid) {
        let submitData = this.formData;
        submitData.Price = this.$options.filters.v_currency(submitData.Price);

        if (submitData.Discounts) {
          submitData.Discounts.forEach((el, index) => {
            submitData.Discounts[
              index
            ].DiscountPrice = this.$options.filters.v_currency(
              el.DiscountPrice
            );
          });
        }

        this.$vs.loading({
          color: "#000",
          container: "#sidebarSubmit",
          scale: 0.45
        });

        let response = this.data.InvoiceSettingGroupID
          ? await StaffApi.updateSettingGroup(submitData, this)
          : await StaffApi.createSettingGroup(submitData, this);
        if (!response.data.error) {
          this.$emit("closeSidebar");
          this.initValues();
        }

        setTimeout(() => {
          this.$vs.loading.close("#sidebarSubmit .con-vs-loading");
        }, 100);
      }

      this.submitBusy = false;
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader();
        reader.onload = e => {
          this.dataImg = e.target.result;
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    }
  },
  components: {
    VuePerfectScrollbar,
    ValidationProvider,
    ValidationObserver,
    vSelect
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 650px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}

.text-select {
  display: block;
}
</style>


<style lang="scss">
#product-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}

.vs-collapse-item--header {
  padding-left: 0;
  padding-bottom: 0.2rem;
}
.vs-collapse-item--content {
  .con-content--item {
    padding: 0 !important;
  }
}
.vs-tabs--content {
  .vs-table-text {
    flex-direction: column;
  }

  .open-item {
    .vs-collapse-item--content {
      max-height: none !important;
    }
  }
}

.vs__dropdown-menu {
  position: relative;
}
</style>
